import styled from 'styled-components';
import { Flex, TextField, IconButton } from '@elementary/common-ui/components';
import { ReactComponent as TrashIcon } from '@elementary/common-ui/assets/trash.svg';
import { space } from '@elementary/common-ui/style/utils';
import { DomainStatus } from '../types';
import DomainChip from './DomainChip';

const ItemContainer = styled(Flex)`
  align-items: center;
  gap: ${space('md')};
  width: 100%;
`;

const DomainInput = styled(TextField)<{ $hasError?: boolean }>`
  flex: 1;
  & .MuiOutlinedInput-root {
    ${({ $hasError, theme }) =>
      $hasError &&
      `
      & fieldset {
        border-color: ${theme.palette.status.error.main};
      }
      &:hover fieldset {
        border-color: ${theme.palette.status.error.main};
      }
      &.Mui-focused fieldset {
        border-color: ${theme.palette.status.error.main};
      }
    `}
  }
`;

const StatusContainer = styled(Flex)`
  align-items: center;
  gap: ${space('sm')};
  min-width: 80px;
`;

type Props = {
  domain: string;
  status: DomainStatus;
  onDomainChange?: (value: string) => void;
  onRemove: () => void;
  onBlur?: () => void;
};

const DomainListItem = ({
  domain,
  status,
  onDomainChange,
  onRemove,
  onBlur,
}: Props) => (
  <>
    <ItemContainer>
      <DomainInput
        size="large"
        placeholder="example.com"
        value={domain}
        onChange={(e) => onDomainChange?.(e.target.value)}
        onBlur={onBlur}
      />
      <StatusContainer>
        <DomainChip status={status} />
      </StatusContainer>
      <IconButton onClick={onRemove} size="small">
        <TrashIcon width={20} />
      </IconButton>
    </ItemContainer>
  </>
);

export default DomainListItem;
